export const PREVIEW_MODAL_HEADER_HEIGHT = 70;
